import React from "react";

const ITEMS = [
  {
    n: "01",
    title: "Real human value",
    body: "We build digital platforms with a deep commitment to real human value, not just engagement metrics.",
  },
  {
    n: "02",
    title: "Respect & reward",
    body: "We design systems that respect users, reward participation, and create meaningful digital experiences.",
  },
  {
    n: "03",
    title: "A fair digital ecosystem",
    body: "We strive to contribute to a more thoughtful and fair digital ecosystem through our products.",
  },
];

export default function WhatWeDoSection() {
  return (
    <section
      id="what-we-do"
      className="bg-[color:var(--kw-bg-alt)]"
      data-testid="whatwedo-section"
    >
      <div className="container-kw section">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="eyebrow">Our Philosophy</div>
            <h2 className="mt-5 font-display font-bold text-4xl md:text-5xl tracking-tight text-[color:var(--kw-black)]">
              What we do.
            </h2>
            <p className="mt-5 text-[color:var(--kw-muted)] text-base md:text-lg leading-relaxed">
              A quiet commitment to building things worth building.
            </p>
          </div>

          <div className="lg:col-span-8">
            {ITEMS.map((it) => (
              <div
                key={it.n}
                className="do-card grid grid-cols-12 gap-6 items-start"
                data-testid={`whatwedo-item-${it.n}`}
              >
                <div className="col-span-12 md:col-span-2 font-display font-black text-3xl md:text-4xl text-[color:var(--kw-black)]">
                  {it.n}
                </div>
                <div className="col-span-12 md:col-span-10">
                  <h3 className="font-display font-semibold text-2xl md:text-3xl tracking-tight text-[color:var(--kw-black)]">
                    {it.title}
                  </h3>
                  <p className="mt-3 text-base md:text-lg text-[color:var(--kw-muted)] leading-relaxed">
                    {it.body}
                  </p>
                </div>
              </div>
            ))}
            <div
              className="h-1 w-full mt-4"
              style={{ background: "var(--kw-border)" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
